import "core-js/modules/es6.map";
import "core-js/modules/es6.array.map";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.weak-map";
import _classCallCheck from "/codebuild/output/src321350362/src/www-public/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src321350362/src/www-public/node_modules/@babel/runtime/helpers/esm/createClass";

var CrossOriginIframeMirror = /*#__PURE__*/function () {
  function CrossOriginIframeMirror(generateIdFn) {
    _classCallCheck(this, CrossOriginIframeMirror);

    this.generateIdFn = generateIdFn;
    this.iframeIdToRemoteIdMap = new WeakMap();
    this.iframeRemoteIdToIdMap = new WeakMap();
  }

  _createClass(CrossOriginIframeMirror, [{
    key: "getId",
    value: function getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
      var idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
      var remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
      var id = idToRemoteIdMap.get(remoteId);

      if (!id) {
        id = this.generateIdFn();
        idToRemoteIdMap.set(remoteId, id);
        remoteIdToIdMap.set(id, remoteId);
      }

      return id;
    }
  }, {
    key: "getIds",
    value: function getIds(iframe, remoteId) {
      var _this = this;

      var idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
      var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
      return remoteId.map(function (id) {
        return _this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap);
      });
    }
  }, {
    key: "getRemoteId",
    value: function getRemoteId(iframe, id, map) {
      var remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
      if (typeof id !== 'number') return id;
      var remoteId = remoteIdToIdMap.get(id);
      if (!remoteId) return -1;
      return remoteId;
    }
  }, {
    key: "getRemoteIds",
    value: function getRemoteIds(iframe, ids) {
      var _this2 = this;

      var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
      return ids.map(function (id) {
        return _this2.getRemoteId(iframe, id, remoteIdToIdMap);
      });
    }
  }, {
    key: "reset",
    value: function reset(iframe) {
      if (!iframe) {
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
        return;
      }

      this.iframeIdToRemoteIdMap["delete"](iframe);
      this.iframeRemoteIdToIdMap["delete"](iframe);
    }
  }, {
    key: "getIdToRemoteIdMap",
    value: function getIdToRemoteIdMap(iframe) {
      var idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);

      if (!idToRemoteIdMap) {
        idToRemoteIdMap = new Map();
        this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
      }

      return idToRemoteIdMap;
    }
  }, {
    key: "getRemoteIdToIdMap",
    value: function getRemoteIdToIdMap(iframe) {
      var remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);

      if (!remoteIdToIdMap) {
        remoteIdToIdMap = new Map();
        this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
      }

      return remoteIdToIdMap;
    }
  }]);

  return CrossOriginIframeMirror;
}();

export { CrossOriginIframeMirror as default };